import React from 'react';
import PropTypes from 'prop-types';

import { TableRow, TableBody, TableCell } from '@mui/material';

import Loader from 'src/components/loaders/Loader';
import EmptyTable from 'src/components/tables/emptyTable';

import TagRow from './tagRow';

function TagsTableBody({
  isLoading,
  isNotFound,
  searchIsNotFound,
  filteredTags,
  page,
  rowsPerPage,
  isSelected,
  setSelectedTags,
  handleOpenMenu,
  handleOpenUpdateModal,
  filterName,
}) {
  const handleClick = (event, id) => {
    setSelectedTags((prevSelected) => {
      const selectedIndex = prevSelected.indexOf(id);

      if (selectedIndex === -1) {
        return [...prevSelected, id]; // Add new ID
      }

      return prevSelected.filter((item) => item !== id); // Remove existing ID
    });
  };

  return (
    <>
      {isLoading ? (
        <TableBody>
          <TableRow>
            <TableCell colSpan={13} sx={{ textAlign: 'center' }}>
              <Loader size={150} />
            </TableCell>
          </TableRow>
        </TableBody>
      ) : (
        <>
          {isNotFound ? (
            <EmptyTable
              filterName={filterName}
              colSpan={12}
              searchIsNotFound={searchIsNotFound}
            />
          ) : (
            <TableBody>
              {filteredTags
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((tag, idx) => {
                  const isItemSelected = isSelected(tag.id);
                  return (
                    <TagRow
                      key={idx}
                      tag={tag}
                      isItemSelected={isItemSelected}
                      handleClick={handleClick}
                      handleOpenMenu={handleOpenMenu}
                      onRowClick={handleOpenUpdateModal}
                    />
                  );
                })}
            </TableBody>
          )}
        </>
      )}
    </>
  );
}

TagsTableBody.propTypes = {
  isLoading: PropTypes.bool,
  isNotFound: PropTypes.bool,
  searchIsNotFound: PropTypes.bool,
  filteredTags: PropTypes.array,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  isSelected: PropTypes.func,
  setSelectedTags: PropTypes.func,
  handleOpenMenu: PropTypes.func,
  handleOpenUpdateModal: PropTypes.func,
  filterName: PropTypes.string,
};

export default TagsTableBody;
